export default "__VITE_ASSET__d614af58__"